/** UI scope for case checking — not an API security boundary. */

import { isAniStaff } from "@/utils/aniPlatformAccess";
import { isAdminUser, type CuroOpsAccessUser } from "@/utils/curoOpsAccess";

export const CASE_CHECKING_REVIEW_PERMISSION = "case_checking:review";

/** Costs, comparison, and model settings in Case Checking Ops. */
export function canUseCaseCheckingAdminTools(
  user: CuroOpsAccessUser | null | undefined,
): boolean {
  return isAniStaff(user) || isAdminUser(user);
}

export function hasCaseCheckingFullAccess(
  permissions: readonly string[] | null | undefined,
): boolean {
  if (!permissions?.length) return false;
  if (permissions.includes("*") || permissions.includes("admin:*")) {
    return true;
  }
  return permissions.includes("case_checking:*");
}

/** Review-only reviewers: `case_checking:review` without `case_checking:*`. */
export function isCaseCheckingReviewOnly(
  permissions: readonly string[] | null | undefined,
): boolean {
  if (!permissions?.length) return false;
  if (hasCaseCheckingFullAccess(permissions)) return false;
  return permissions.includes(CASE_CHECKING_REVIEW_PERMISSION);
}
